import { useEffect, useState } from 'react'
import { apiURL } from '../../utilities/URLs'
import { customerData, CustomerQRCodeData } from '../../utilities/CustomerData'
import { refreshAccessToken } from '../../utilities/extensions'
import { useNavigate } from 'react-router-dom'

export function ReadyCloud() {
  const navigate = useNavigate()
  const [generatingQRCode, setGeneratingQRCode] = useState(true)
  const [generatedQRCode, setGeneratedQRCode] = useState(false)

  useEffect(() => {
    const handleGenerateQRCode = async () => {
      const form = new FormData()
      form.append('createReturnInfo', JSON.stringify({
        leadId: customerData.customerLeadData.leadId,
        customerId: customerData.customerLeadData.leadContact.contactId
      }))

      const createReturnResponse = await fetch(`${apiURL}/api/generateReadyCloudQRCode`, {
        method: 'POST',
        headers: {
          'Authorization': customerData.accessToken
        },
        body: form
      })
      const createReturnData = await createReturnResponse.json()
      setGeneratingQRCode(false)

      if(createReturnData.response.error) {
        if(createReturnData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleGenerateQRCode() : navigate('/', { state: { expired: true } })
        } else if(createReturnData.response.error === 'No IDme Attributes.')
          navigate('/resyncIDme') 
          else
          console.error(createReturnData.response.error)
      } else {
        customerData.customerQRCodeData = new CustomerQRCodeData({ qrCodeId: '1', customerId: customerData.customerLeadData.leadContact.contactId, qrCodeURL: createReturnData.response.qrCodeURL })
        setGeneratedQRCode(true)
      }
    }

    handleGenerateQRCode()
  }, [])

  const handleViewQRCode = async () => {
    const s3UrlResponse = await fetch(`${apiURL}/api/generateS3URL?url=${encodeURIComponent(customerData.customerQRCodeData.qrCodeURL)}`, {
      headers: {
        'Authorization': customerData.accessToken
      }
    })
    const s3UrlData = await s3UrlResponse.json()
    if (s3UrlData.response.error) {
      if (s3UrlData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleViewQRCode() : navigate('/', { state: { expired: true } })
      } else
        console.error(s3UrlData.response.error)
    } else
      return window.innerWidth <= 768 ? window.location.href = s3UrlData.response.s3Url : window.open(s3UrlData.response.s3Url, '_blank')
  }

  return (
    <div className='w-full flex flex-col items-center gap-4'>
      {generatingQRCode ? (
        <div className='flex flex-row items-center justify-center gap-2'>
          <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
          <p>Generating QR Code, please do not leave or reload this page...</p>
        </div>
      ) : (
        generatedQRCode ? (
          <div className='flex flex-col items-center gap-4'>
            <p className='font-bold text-2xl'>Congratulations!</p>
            <p>We have successfully generated your QR Code!</p>
            <p>When you go to download your documents, it will be attached to your packet.</p>
            <p>You may also view it at any time in your dashboard, under your Document Center.</p>
            <div className='w-full flex flex-row gap-2'>
              <button
                onClick={handleViewQRCode}
                className='w-full py-2 text-white rounded max-sm:mb-4 bg-primaryColor hover:bg-primaryDarkColor transition duration-200'>
                View QR Code
              </button>
              <button
                onClick={() => navigate('/downloadDocument')}
                className='w-full py-2 text-white rounded max-sm:mb-4 bg-secondaryColor hover:bg-secondarDarkColor transition duration-200'>
                Return To Dashboard
              </button>
            </div>
          </div>
        ) : (
          <div className='flex flex-col items-center gap-4'>
            <p className='text-red-500'>Failed to generate QR Code. Please try again.</p>
            <button className='bg-red-500 text-white px-4 py-2 rounded-lg'>
              Retry
            </button>
          </div>
        )
      )}
    </div>
  )
}